import {Component, OnInit, Output, EventEmitter} from '@angular/core';

import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'view',
	templateUrl: './view.component.html',
	styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {
	constructor(
		private log: LogService
	) {}


	view = true;


	ngOnInit() {
	}


}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/view/view.component.ts